// src/hooks/useAdvertise.js
import {useQuery} from 'react-query';
import {fetchAdvertise} from "../api/advertiseApi";

export const useAdvertise = (pageNumber, pageSize) => {
    return useQuery(['advertise', pageNumber, pageSize], () => fetchAdvertise(pageNumber, pageSize), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
};
